import { Component } from 'vue';

class TableComponentLoader {
	public loadBatchesOverviewTable(): Promise<Component> {
		return import('@/presentation/components/the-batches-overview/the-batches-overview.vue');
	}
}

export default new TableComponentLoader();
